<template>
  <nav class="sidebar">
    <div class="sidebar-sticky">
      <ul class="nav flex-column">
        <facet-group
          v-for="facetGroup in facetGroups"
          :key="facetGroup.groupName"
          :group-name="facetGroup.groupName"
          :facets="facetGroup.facets"
          :selected-filters="selectedFilters"
          @toggle-filter="onToggleFilter"
        />
      </ul>
    </div>
  </nav>
</template>

<script>
  import FacetGroup from './facet-group'

  export default {
    components: {
      FacetGroup
    },
    props: {
      facetGroups: {
        type: Array,
        required: true
      },
      selectedFilters: {
        type: Object,
        required: true
      }
    },
    methods: {
      onToggleFilter(payload) {
        this.$emit('toggle-filter', payload);
      }
    }
  };
</script>
